import { apiRequest, ResultAPI } from 'app/requests/apiRequest';
import env from '.env.json';

export const translateText = async (data: any) => {
  const result = await apiRequest('/api/translates', 'post', data, false, env.URL_API_NODE) as ResultAPI;
  return result.data ?? '';
};
